export const SIGNATURE_CLEAR_ALL = 'signature:clear-all';
export const SIGNATURE_SAVE = 'signature:save';

export const DRAWER_TOGGLE = 'drawer:toggle';

export const REFERENCE_INIT = 'reference:init';
export const REFERENCE_FOUND = 'reference:found';
export const REFERENCE_NOT_FOUND = 'reference:not-found';
export const REFERENCE_CLEAR = 'reference:clear';
export const REFERENCE_GET = 'reference:get';

export const CLIENTE_INIT = 'cliente:init';
export const CLIENTE_FOUND = 'cliente:found';
export const CLIENTE_NOT_FOUND = 'cliente:not-found';
export const CLIENTE_CLEAR = 'cliente:clear';
export const CLIENTE_GET = 'cliente:get';

export const ATTACHMENT_INIT = 'attachment:init';
export const ATTACHMENT_LOAD = 'attachment:load';

export const LICENSE_PLATE_INIT = 'license-plate:init';
export const LICENSE_PLATE_FOUND = 'license-plate:found';
export const LICENSE_PLATE_NOT_FOUND = 'license-plate:not-found';
export const LICENSE_PLATE_CLEAR = 'license-plate:clear';
export const LICENSE_PLATE_GET = 'license-plate:get';

export const TOAST_TRIGGER = 'toast:trigger';

export const PAGE_VISIT = 'pinecone:end'; // PineCone router specific event
